<div
  class="not-applicable-label"
  [matTooltip]="tooltipDynamicText"
  matTooltipPosition="right"
  matTooltipClass="tooltip-container"
>
  {{ 'common.notAvailable' | labelsProvider }}
</div>
